module.exports = __webpack_public_path__ + "static/foodpage-banner-54df6f833c7b798f7a00c204c5d2af13.jpg";